import { STORAGE } from "../storage";
import { Store } from "../../reducers/store";
import { extractDeviceUuidFromToken } from "./extractDeviceUuidFromToken";

/**
 * Get device UUID from multiple sources with fallback priority:
 * 1. Local storage (most reliable)
 * 2. JWT token (if available)
 * 3. Redux state token (if available)
 * 
 * @returns {Promise<string|null>} Device UUID or null if not found
 */
export const getDeviceUuid = async () => {
    try {
        // First priority: Check local storage
        const storedUuid = await STORAGE.get('deviceUuid');
        if (storedUuid) {
            console.log('GET_DEVICE_UUID - Found UUID in storage:', storedUuid);
            return storedUuid;
        }

        // Second priority: Extract from current token in Redux state
        const state = Store.getState();
        const currentToken = state.data.token;
        
        if (currentToken) {
            const tokenUuid = extractDeviceUuidFromToken(currentToken);
            if (tokenUuid) {
                console.log('GET_DEVICE_UUID - Extracted UUID from token:', tokenUuid);
                
                // Store it for future use
                await STORAGE.set('deviceUuid', tokenUuid);
                return tokenUuid;
            }
        }

        // Third priority: Check stored token
        const storedToken = await STORAGE.get('token');
        if (storedToken && storedToken !== currentToken) {
            const tokenUuid = extractDeviceUuidFromToken(storedToken);
            if (tokenUuid) {
                console.log('GET_DEVICE_UUID - Extracted UUID from stored token:', tokenUuid);
                
                // Store it for future use
                await STORAGE.set('deviceUuid', tokenUuid);
                return tokenUuid;
            }
        }

        console.warn('GET_DEVICE_UUID - No device UUID found in any source');
        return null;

    } catch (error) {
        console.error('GET_DEVICE_UUID - Error retrieving device UUID:', error);
        return null;
    }
};

/**
 * Store device UUID to local storage
 * @param {string} uuid - Device UUID to store
 * @returns {Promise<void>}
 */
export const storeDeviceUuid = async (uuid) => {
    if (uuid) {
        await STORAGE.set('deviceUuid', uuid);
        console.log('STORE_DEVICE_UUID - UUID stored:', uuid);
    }
};
